import { ErrorState } from "@/components/ErrorState";

export default function ServerError({ onRetry }) {
  const retry = onRetry || (() => window.location.reload());
  return <ErrorState leftDigit="5" rightDigit="0" ns="serverError" seoTitle="500" testid="server-error-page" onRetry={retry} />;
}
